<template>
  <v-dialog
    :model-value="dialog"
    :eager="eager"
    :fullscreen="fullscreen"
    :width="width"
    :persistent="persistent"
    :transition="transition"
    no-click-animation
    :scrim="!hideOverlay"
    :class="{ popup }"
    @keydown.esc="$emit('cancel')"
    @click:outside="emitCancelIfNotPersistent"
  >
    <slot name="header" />
    <app-card class="ma-0">
      <v-card-title
        v-if="!fullscreen && Boolean($slots.title)"
        class="px-4 pb-0 pt-4"
        :class="{
          'pb-4': (Boolean($slots.title) && Boolean($slots.content)) || (compactDesktopHeader && !Boolean($slots.content))
        }"
      >
        <h1 class="font-weight-bold font-size-title-small break-word title-element my-0">
          <slot name="title" />
        </h1>
      </v-card-title>
      <fill-area
        ref="fillArea"
        :class="{ 'px-4 pt-4 pb-6': !disableContentPadding, 'mt-12': Boolean($slots.header) }"
        use-max-height
        :disabled="fillAreaDisabled"
        message-dialog-content
        :use-min-height="$vuetify.display.mobile && fullscreen"
        :offset="offset === null ? fillAreaOffset : offset"
      >
        <template #header>
          <slot name="content-header" />
        </template>
        <v-card-text class="pa-0 font-size-big">
          <slot name="content" />
        </v-card-text>
      </fill-area>

      <section v-if="anyButtonSlotUsed">
        <v-divider class="border-post-detail-15" />
        <v-card-actions class="pa-4 justify-end">
          <div class="d-flex">
            <slot name="action-buttons" />

            <the-button v-if="Boolean($slots.cancel)" secondary :loading="cancelButtonLoading" small class="dialog-button" @click="$emit('cancel')">
              <slot name="cancel" />
            </the-button>

            <the-button v-if="Boolean($slots.ok)" class="ml-4 dialog-button" :disabled="okButtonDisabled" :loading="okButtonLoading" small @click="$emit('ok')">
              <slot name="ok" />
            </the-button>
          </div>
        </v-card-actions>
      </section>
    </app-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    okButtonDisabled: {
      type: Boolean,
      default: false
    },
    okButtonLoading: {
      type: Boolean,
      default: false
    },
    cancelButtonLoading: {
      type: Boolean,
      default: false
    },
    hideOverlay: {
      type: Boolean,
      default: false
    },
    eager: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    popup: {
      type: Boolean,
      default: false
    },
    transition: {
      type: [String, Boolean],
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    disableContentPadding: {
      type: Boolean,
      default: false
    },
    compactDesktopHeader: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 600
    },
    offset: {
      type: Number,
      default: null
    }
  },
  computed: {
    anyButtonSlotUsed() {
      return Boolean(this.$slots.cancel || this.$slots.ok || this.$slots["action-buttons"])
    },
    fillAreaOffset() {
      if (this.$vuetify.display.mobile) {
        if (!this.anyButtonSlotUsed) {
          return 0
        }
        return 100
      }
      return this.$slots.title ? 205 : 190
    },
    // V-card-text has already overflow auto
    // using fillarea inside dialog and together with inputs introduces some problems
    // on mobile browsers that e.g do mess with layout when input is focused
    fillAreaDisabled() {
      return this.$vuetify.display.mobile && this.fullscreen
    }
  },
  methods: {
    emitCancelIfNotPersistent() {
      if (!this.persistent) {
        this.$emit("cancel")
      }
    },
    getFillAreaRef() {
      return this.$refs.fillArea
    }
  }
}
</script>

<style lang="scss" scoped>
.v-dialog:not(.v-dialog--fullscreen) {
  margin: 16px !important;
}

:deep(.v-dialog--fullscreen) {
  height: auto;
}

.v-dialog.popup {
  z-index: var(--z-index-popups) !important;
}

.title-element {
  white-space: pre-wrap;
}

.dialog-button {
  display: block;

  :deep(.v-btn__content) {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
